import type { createBffClient } from 'bff-api/mitt-malarenergi';

// Only enum-like params; ids and customer numbers must never reach Sentry.
const SAFE_PATH_PARAMS = [
  'infraService',
  'utilityType',
  'groupBy',
  'openOrClose',
];

function pickSafePathParams(path: unknown): Record<string, string> {
  if (!path || typeof path !== 'object') {
    return {};
  }
  const params: Record<string, string> = {};
  for (const name of SAFE_PATH_PARAMS) {
    const value = (path as Record<string, unknown>)[name];
    if (value !== undefined && value !== null) {
      params[name] = String(value);
    }
  }
  return params;
}

export class BffRequestError extends Error {
  constructor(
    public readonly status: number | undefined,
    public readonly method: string,
    public readonly endpoint: string,
    public readonly details: unknown,
    public readonly pathParams: Record<string, string> = {},
  ) {
    super(`${method} ${endpoint} failed${status ? ` (${status})` : ''}`);
    this.name = 'BffRequestError';
  }
}

export function addErrorStatus<
  TClient extends ReturnType<typeof createBffClient>,
>(client: TClient): TClient {
  client.interceptors.error.use((error, response, request, options) => {
    return new BffRequestError(
      response?.status,
      request?.method ?? 'GET',
      options?.url ?? 'unknown',
      error,
      pickSafePathParams(options?.path),
    );
  });
  return client;
}
